import React from "react";
import PlatformIcon from "../PlatformIcon";
import styles from "./PlatformCheckbox.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * Interactive component. A checkbox that allows the user to select incompatible platforms for a feed.
 * Selected options will turn a lighter shade.
 */
export function PlatformCheckbox({
  platformType,
  isIncompatible,
  setIncompatiblePlatforms,
}) {
  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setIncompatiblePlatforms(isChecked, platformType);
  };

  return (
    <div>
      <label htmlFor={platformType} hidden>
        {platformType}
      </label>

      {/* <input
        type="checkbox"
        value={platformType}
        name={platformType}
        hidden
        checked={isIncompatible}
        onChange={handleChange}
      /> */}
      <button
        className={classNames(styles.checkbox, {
          [styles.inactive]: !isIncompatible,
        })}
        onClick={setIncompatiblePlatforms}
      >
        <PlatformIcon platformType={platformType} />
      </button>
    </div>
  );
}

PlatformCheckbox.propTypes = {
  /**
   * String that determines the icon platform type.
   */
  platformType: PropTypes.oneOf(["PC", "Apple", "Android"]),
  /**
   * Boolean that state whether the platform is checked or not.
   */
  isIncompatible: PropTypes.bool,
  /**
   * Function that fires when a checkbox item is toggled.
   */
  setIncompatiblePlatforms: PropTypes.func,
};
